export const getBadgeByIds = (state, badgeIds) => state.badges.find((b) => badgeIds.includes(b.id));
export const getAllBadges = (state) => state.badges;
